module.exports = __webpack_public_path__ + "img/Group 427320372.8fa597dc.svg";